import { ReportStatus, ReportType } from '../api/reports.dao';

const reportTypeLabels = {
    [ReportType.EVENT_REPORT]: {
        id: 'oe.common.report',
        defaultMessage: 'Report',
        description: 'Option label'
    },
    [ReportType.PRE_EVENT_DATA]: {
        id: 'oe.common.preEventData',
        defaultMessage: 'Pre-event data',
        description: 'Option label'
    },
    [ReportType.ZOOM_WEBINAR_REGISTRATION]: {
        id: 'oe.common.zoomWebinarRegistration',
        defaultMessage: 'Zoom Webinar Registration',
        description: 'Option label'
    },
    [ReportType.ZOOM_WEBINAR_ATTENDEE]: {
        id: 'oe.common.zoomWebinarAttendee',
        defaultMessage: 'Zoom Webinar Attendee',
        description: 'Option label'
    },
    [ReportType.MEETING_INTERACTIONS_REPORT]: {
        id: 'oe.common.meetingInteractionReport',
        defaultMessage: 'Meeting Interaction Report',
        description: 'Option label'
    },
    [ReportType.EVENT_INTERACTIONS_REPORT]: {
        id: 'oe.common.eventInteractionsReport',
        defaultMessage: 'Event Interactions Report',
        description: 'Option label'
    },
    [ReportType.ATTENDEE_INTERACTIONS_REPORT]: {
        id: 'oe.common.attendeeInteractionReport',
        defaultMessage: 'Attendee Interaction Report',
        description: 'Option label'
    },
    [ReportType.REGISTRANTS_BY_SESSION_REPORT]: {
        id: 'oe.common.registrantsBySession',
        defaultMessage: 'Registrants by Session',
        description: 'Option label'
    },
    [ReportType.MEETING_REGISTRATION_REPORT]: {
        id: 'oe.common.meetingRegistrationReport',
        defaultMessage: 'Meeting Registration Report',
        description: 'Option label'
    },
    [ReportType.EVENT_REGISTRATION_REPORT]: {
        id: 'oe.common.eventRegistrationReport',
        defaultMessage: 'Event Registration Report',
        description: 'Option label'
    },
    [ReportType.ZOOM_MEETING_REGISTRATION_REPORT]: {
        id: 'oe.common.zoomMeetingRegistrationReport',
        defaultMessage: 'Zoom Meeting Registration Report',
        description: 'Option label'
    },
    [ReportType.OTHER_REPORT]: {
        id: 'oe.common.other',
        defaultMessage: 'Other',
        description: 'Option label'
    }
};

const reportStatusLabels = {
    [ReportStatus.PENDING]: {
        id: 'oe.common.pending',
        defaultMessage: 'Pending',
        description: 'Option label'
    },
    [ReportStatus.READY]: {
        id: 'oe.common.ready',
        defaultMessage: 'Ready',
        description: 'Option label'
    },
};

const webinarReportsTitle = 'Select Webinars for Report';
const zoomMeetingsReportsTitle = 'Select Zoom Meetings for Report';
const meetingRegistrationReportText = {
    id: 'oe.reports.generateMeetingRegistrationReport',
    defaultMessage: 'Generate Meeting Registration Report',
    description: 'Title text'
};

export {
    reportTypeLabels,
    reportStatusLabels,
    webinarReportsTitle,
    zoomMeetingsReportsTitle,
    meetingRegistrationReportText,
};
